import { Component, computed, inject, input } from '@angular/core';
import { Button, Skeleton } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { RandomColorPipe } from '../../../../shared/pipes/random-color-pipe';
import { LocationsStore } from '../../../locations/store/locations.store';
import { LocationAddressPipe } from '../../../locations/pipes/location-address-pipe';
import { LocationNamePipe } from '../../../locations/pipes/location-name-pipe';
import { RouterLink } from '@angular/router';
import { ErrorComponent } from '../../../../shared/components/error-component/error-component';
import { TranslocoPipe } from '@jsverse/transloco';
import { DashboardListCardSkeleton } from '../dashboard-list-card-skeleton/dashboard-list-card-skeleton';

@Component({
  selector: 'app-dashboard-locations-card',
  imports: [
    Button,
    NgIcon,
    RandomColorPipe,
    LocationAddressPipe,
    LocationNamePipe,
    RouterLink,
    ErrorComponent,
    Skeleton,
    TranslocoPipe,
    DashboardListCardSkeleton,
  ],
  templateUrl: './dashboard-locations-card.html',
})
export class DashboardLocationsCard {
  private locationsStore = inject(LocationsStore);

  organizationId = input.required<string>();

  private totalLocations = computed(() => this.locationsStore.locations() ?? []);
  protected locations = computed(() =>
    this.totalLocations()
      .filter((l) => !l.isDeleted)
      .slice(0, 3),
  );
  protected totalLocationsCount = computed(() => this.totalLocations().length);

  protected isLoading = this.locationsStore.isLoading;
  protected error = this.locationsStore.error;

  protected onClickReload() {
    this.locationsStore.load();
  }
}
